export { default as GlobalLoadingPage } from './GlobalLoadingPage';
